import { AdvanceFilter, MaxProjectionYear } from "../helpers/constant";
import { CommonHelper } from "../helpers";
export default {
  data() {
    return {
      loanInfo: {},
      selectedtabComponent: "chart-area",
      chartGraphData: [],
      chartProperties: {},
      chartTabContent: [
        {
          text: "Balance",
          id: "chart-area",
          active: true,
        },
        {
          text: "Repayments",
          id: "chart-bar",
          active: false,
        },
      ],
      chartTabContentTableView: [
        {
          text: "Details",
          id: "chart-area",
          active: true,
          visible: true,
        },
      ],
      leftToolSummary: [{ key: "Net CashFlow", value: "View Details" }],
      rightToolSummary: [
        { key: "Total Loan Repayment", value: "$0" },
        { key: "Total Interest", value: "$0" },
        { key: "Loan Paid In", value: "0 years" },
      ],
      chartData: {
        barChartdata: [],
        areaChartdata: [],
      },
      projectionYear: {
        Value: 0,
        Maxvalue: MaxProjectionYear,
        IsError: false,
        ErrorText: [],
      },
    };
  },
  computed: {
    barChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 20],
        domainY: [0, 600000],
        tickQuantityY: 5,
        color: ["#1f55af", "#f4c508"],
        legendItems: ["Principal", "Interest"],
        yAxisLabel: "Repayment Amount",
        legendKeyType: "bar",
        areaLegendKey: "bar",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
        isHideFirstTick: true,
      };
    },
    lineChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 20],
        domainY: [0, 600000],
        tickQuantityY: 5,
        color: ["#1f55af", "#f4c508"],
        legendItems: ["Principal", "Interest"],

        legendKeyType: "bar",
        areaLegendKey: "bar",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
        isHideFirstTick: true,
      };
    },
    areaChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 2, 4, 6, 8, 10],
        domainY: [0, 600000],
        tickQuantityY: 5,
        areaLegendItems: "Loan",
        areaLegendKey: "bar",
        lineChartColor: "#2056af",
        yAxisLabel: "Loan Balance",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
        isHideFirstTick: true,
      };
    },
  },
  methods: {
    onChangeChartTab(tabId) {
      this.selectedtabComponent = tabId;
      if (this.selectedtabComponent == "chart-area") {
        this.chartProperties = this.areaChartProperties;

        this.chartGraphData = this.chartData.areaChartdata;
      } else {
        this.chartProperties = this.barChartProperties;

        this.chartGraphData = this.chartData.barChartdata;
      }
    },

    DescriptionAdditionalForm(data, typeId) {
      if (data == undefined || data == "") {
        if (typeId == AdvanceFilter.Interest_Rate) {
          return "Interest Rate";
        } else if (typeId == AdvanceFilter.Repayment) {
          return "Repayment";
        } else if (typeId == AdvanceFilter.LoanTerm) {
          return "Loan Term";
        } else if (typeId == AdvanceFilter.DrawDown) {
          return "Drawdown";
        }
      } else {
        return data;
      }
    },
    createLoanModel(screenLoanData) {
      let saveLoanModel = Object.assign({}, screenLoanData);
      delete saveLoanModel["regex"];
      delete saveLoanModel["date"];
      delete saveLoanModel["text"];
      delete saveLoanModel["profileName"];
      delete saveLoanModel["amount"];
      delete saveLoanModel["tagName"];
      delete saveLoanModel["name"];
      delete saveLoanModel["entityName"];
      delete saveLoanModel["factOutstandingBalance"];
      delete saveLoanModel["isFromFact"];
      delete saveLoanModel["durationType"];
      delete saveLoanModel["loanTypeName"];
      delete saveLoanModel["clientName"];
      delete saveLoanModel["userdurationType"];
      delete saveLoanModel["Interest"];
      delete saveLoanModel["isFactDataChanges"];
      delete saveLoanModel["ErrorText"];
      delete saveLoanModel["IsError"];
      return saveLoanModel;
    },

    ResetBarChartProperties() {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(this.loanModel.barchartData.maxYAxis),
        5
      );
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }

      this.barChartProperties.domainX = [
        0,
        this.loanModel.barchartData.maxXAxis,
      ];
      this.barChartProperties.domainY = [0, roundOffYaxis];
    },
    ResetAreaChartProperties() {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(this.loanModel.areaChartData.maxYAxis),
        5
      );
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }

      this.areaChartProperties.domainX = [0, this.projectionYear.Value];
      this.areaChartProperties.tickX = 0;
      this.areaChartProperties.domainY = [0, roundOffYaxis];
    },

    GetBarChartProperties(chartData, legendItems, legendColors) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );
      let roundOffYMinaxis =
        chartData.minYAxis > 0
          ? -CommonHelper.getRoundOffValueForAxis(
              0,
              Math.ceil(chartData.minYAxis),
              5
            )
          : 0;
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.barChartProperties.legendItems = legendItems;
      this.barChartProperties.color = legendColors;

      this.barChartProperties.domainX = [0, chartData.maxXAxis];
      this.barChartProperties.domainY = [roundOffYMinaxis, roundOffYaxis];
      return this.barChartProperties;
    },
    GetAreaChartProperties(chartData, legendItems) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );

      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.areaChartProperties.areaLegendItems = legendItems;
      this.areaChartProperties.domainX = [0, this.projectionYear.Value];
      this.areaChartProperties.tickX = 0;
      this.areaChartProperties.domainY = [0, roundOffYaxis];
      return this.areaChartProperties;
    },

    async saveLoanData(apiResponse, isUpdate) {
      if (apiResponse && apiResponse.status == 200) {
        this.setNotificationSummary({
          isShow: true,
          variation: "success",
          text:
            isUpdate == 1
              ? `Loan instance ${this.selectedLoanData.description} has been updated.`
              : `Loan instance ${this.selectedLoanData.description} has been added.`,
        });
      } else {
        this.setNotificationSummary({
          isShow: true,
          variation: "error",
          text: `Failed to add Loan instance ${this.selectedLoanData.description}.`,
        });
      }
      this.$router.push({ name: "loan-instance-selection" });
    },
  },
};
